import React from "react";
import ValueHypothesisReport from "./ValueHypothesisReport";
import {
  EditUnquantifiedKPIModal,
  EditQuantifiedKPIModal
} from "../../components/Discovery/KPIModal";
import DiscoveryContentWrapper from "../Discovery/DiscoveryContentWrapper";
import { useMobileMediaQuery } from "../../components/Responsive";
import CostOfStatusQuoChartProvider from "./components/CostOfStatusQuoChartProvider";
import ValueHypothesisProvider from "./components/ValueHypothesisProvider";

const ValueHypothesis = () => {
  const isMobile = useMobileMediaQuery();

  return (
    <DiscoveryContentWrapper format={"wide"} isMobile={isMobile}>
      <ValueHypothesisProvider reportMode={false}>
        <CostOfStatusQuoChartProvider>
          <ValueHypothesisReport />
          <EditUnquantifiedKPIModal />
          <EditQuantifiedKPIModal />
        </CostOfStatusQuoChartProvider>
      </ValueHypothesisProvider>
    </DiscoveryContentWrapper>
  );
};

export default ValueHypothesis;
